import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { AvatarComponent } from '../../../../helpers/generateAvatarRamdomColor';
import { toDateTimePrintFormat } from '../../../../helpers/dateFormat';
import { validStatus, statusEnum } from '../../../../interfaces/SupportListInterface';

// Subject comes from the ticket's optional form answers ("Subject" question),
// falling back to the legacy `subject` column. Mirrors the API helper
// getSupportSubjectAndDescription so the list shows the same value as emails/detail.
const getSubject = (row: any): string => {
  const fromQuestionAnswers = (row?.questionAnswers || []).find(
    (qa: any) => (qa?.question || '').trim().toLowerCase() === 'subject',
  )?.answer;
  return (fromQuestionAnswers || row?.subject || '').trim();
};

const ucfirst = (text: string) => {
  if (text === '' || text === undefined) {
    return '';
  }
  return text[0].toUpperCase() + text.substring(1).toLowerCase();
};

const getPriorityColor = (itemPriority: string) => {
  if (itemPriority === 'HIGH') return 'danger';
  if (itemPriority === 'MEDIUM') return 'warning';
  return 'primary';
};

const buildSupportListColumns = (showSchool = false) => [
  {
    name: 'Subject',
    grow: 2,
    minWidth: '200px',
    cell: (row: any) => {
      const subject = getSubject(row);
      return (
        <Link to={`/support/${row.id}`} className="font-weight-600">
          {subject || (row.type || '').replaceAll('_', ' ') || 'View'}
        </Link>
      );
    },
  },
  ...(showSchool
    ? [
        {
          name: 'School',
          selector: (row: any) => row.school?.name,
          grow: 1,
          minWidth: '150px',
          cell: (row: any) => row.school?.name || '',
        },
      ]
    : []),
  {
    name: 'User',
    grow: 2,
    minWidth: '150px',
    cell: (row: any) => (
      <div className="d-flex align-items-center">
        <AvatarComponent
          name={`${row.user?.firstName || ''} ${row.user?.lastName || ''}`.trim()}
          size="36"
          userPicture={row.user?.picture}
        />
        <span className="ml-2 mb-0 text-sm font-weight-bold">
          {row.user?.firstName || ''} {row.user?.lastName || ''}
        </span>
      </div>
    ),
  },
  {
    name: 'Department',
    selector: (row: any) => row.department,
    grow: 1,
    cell: (row: any) => row.department,
  },
  {
    name: 'Category',
    grow: 1,
    cell: (row: any) => (row.type || '').replaceAll('_', ' '),
  },
  {
    name: 'Priority',
    selector: (row: any) => row.priority,
    grow: 1,
    cell: (row: any) => (
      <Badge color={getPriorityColor(row.priority)} pill>
        {ucfirst(row.priority)}
      </Badge>
    ),
  },
  {
    name: 'Status',
    selector: (row: any) => row.status,
    grow: 1,
    cell: (row: any) => (
      <Badge color={validStatus[row.status as statusEnum]?.color || 'secondary'} pill>
        {ucfirst(row.status)}
      </Badge>
    ),
  },
  {
    name: 'Date',
    selector: (row: any) => row.createdAt,
    grow: 1,
    cell: (row: any) => toDateTimePrintFormat(row.createdAt),
  },
];

export default buildSupportListColumns;
